/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { Options, Unwrappable, RequestResult } from '../.kubb/client'
import type {
  GetPLForSelfByAccountOptions,
  GetPLForSelfByAccountResponses,
} from '../types/GetPLForSelfByAccount'
import { client, withUnwrap } from '../.kubb/client'

/**
 * @summary Get account-by-account PL breakdown for the logged in user
 * {@link /v1/pl/self}
 */
export function getPLForSelfByAccount<ThrowOnError extends boolean = true>(
  options: Options<GetPLForSelfByAccountOptions, ThrowOnError> = {},
): Unwrappable<RequestResult<GetPLForSelfByAccountResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return withUnwrap(
    request({
      method: 'GET',
      url: '/v1/pl/self',
      security: [
        { type: 'http', scheme: 'bearer' },
        { type: 'apiKey', name: 'Authorization', in: 'header' },
      ],
      ...config,
      throwOnError: config.throwOnError ?? true,
    }) as Promise<RequestResult<GetPLForSelfByAccountResponses, ThrowOnError>>,
  )
}
